// Re-exporta do pacote shared — fonte única de verdade
export { COUNTRY_CONFIGS, COUNTRY_LIST, ACTIVE_COUNTRIES, ALL_COUNTRIES, COUNTRY_LOCALE_MAP, RTL_LOCALES, ENGLISH_AS_OFFICIAL } from '@pakt/shared'
export type { CountryConfig, CountryPaymentConfig, NationalIdConfig, PaymentMethodType } from '@pakt/shared'
import { COUNTRY_CONFIGS, ALL_COUNTRIES } from '@pakt/shared'
import type { CountryConfig } from '@pakt/shared'

// Helper functions used by existing pages
export function getCountryConfig(code: string): CountryConfig | undefined {
  return COUNTRY_CONFIGS[code]
}

export function getAllCountries(): CountryConfig[] {
  return ALL_COUNTRIES
}
